/**
 * How a folder's colour KEY (shared/types `FOLDER_COLOR_KEYS`) renders. The
 * class names are declared in apps/web/src/index.css beside the rail rules,
 * mixing a hue into the theme's own tertiary background — so the same key
 * reads right on the dark, dim and light themes.
 */
import { FOLDER_COLOR_KEYS, type FolderColorKey } from '@papan/types'

export { FOLDER_COLOR_KEYS }
export type { FolderColorKey }

/** The class that paints a folder glyph in `color`; '' for the default. */
export const folderColorClass = (color: FolderColorKey | null | undefined): string =>
  color ? `ws-folder-color-${color}` : ''

/** The swatch hue for menus and pickers — the same hue the class mixes in. */
export const FOLDER_COLOR_SWATCH: Record<FolderColorKey, string> = {
  violet: '#8b5cf6',
  blue: '#3b82f6',
  teal: '#14b8a6',
  green: '#22c55e',
  amber: '#f59e0b',
  rose: '#f43f5e',
  slate: '#94a3b8',
}
